import React from 'react';
import { css } from '@emotion/css';

import { cn } from '@lyearn/style';
import { Divider, Stack, Typography } from '@lyearn/ui';
import { SkillType } from '@/types/schema';

import RubricDetails from './RubricDetails';

const w316 = css`
  width: 316px;
`;

const SkillDetailsInTooltip = ({ skill }: { skill: SkillType }) => {
  return (
    <Stack className={cn(w316, 'max-h-[72rem] overflow-y-auto')} direction="col">
      <Stack className="w-full py-16 px-20" direction="col" gapY={8}>
        <Typography color="text-text-primary" variant="label-02">
          {skill.name}
        </Typography>
        <Typography
          className="whitespace-pre-line"
          color="text-text-secondary"
          variant="body-short-03">
          {skill.description}
        </Typography>
      </Stack>
      <Divider />
      <Stack className="w-full p-20" direction="col" gapY={24}>
        {skill.rubrics.map((rubric, index) => {
          // It is not the best practice to use Index as key.
          // But since the Rubrics will not get reordered, we can use it
          return <RubricDetails key={index} rubric={rubric} />;
        })}
      </Stack>
    </Stack>
  );
};

export default React.memo(SkillDetailsInTooltip);
